import JobEquipmentSummaryContainer from "@legacy/jobs/JobEquipmentSummaryContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { JOBS_ROUTES } from "@routes/jobs"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function JobEquipmentSummaryEdit() {
    const jobId = window.JOB_ID

    const [detailsRoute] = useSlugExtractor([JOBS_ROUTES.DETAILS], jobId)
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const detailsBackDestination = hasPermission("jobs_view_permission", PERMISSION_LEVEL.FULL)
        ? detailsRoute
        : undefined

    return (
        <AppFrame.Root pageId="JobEquipmentSummaryEdit" navigationType="inner">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageInnerTitle
                            label="Job Equipment Summary"
                            backDestination={detailsBackDestination}
                        />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <JobEquipmentSummaryContainer addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
